import ProxyBase from '../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getHighLight(params) {
    return this.post('PortfolioInsights/Segment/Highlight', params)
  }

  getProvince(params) {
    return this.post('PortfolioInsights/Segment/ByProvince', params)
  }

  exportProvince(params) {
    return this.post(
      'PortfolioInsights/Segment/ByProvince/Export',
      params,
      undefined,
      'download',
    )
  }

  getIndustry(params) {
    return this.post('PortfolioInsights/Segment/ByIndustry', params)
  }

  exportIndustry(params) {
    return this.post(
      'PortfolioInsights/Segment/ByIndustry/Export',
      params,
      undefined,
      'download',
    )
  }

  getBusinessSize(params) {
    return this.post('PortfolioInsights/Segment/BussinessSize', params)
  }

  exportBusinessSize(params) {
    return this.post(
      'PortfolioInsights/Segment/BussinessSize/Export',
      params,
      undefined,
      'download',
    )
  }

  getYearOperation(params) {
    return this.post('PortfolioInsights/Segment/YearOfOperation', params)
  }

  exportYearOperation(params) {
    return this.post(
      'PortfolioInsights/Segment/YearOfOperation/Export',
      params,
      undefined,
      'download',
    )
  }

  getMaxDate(params) {
    return this.post('PortfolioInsights/MaxDate', params)
  }
}
export default new Proxy()
